import { useSyncExternalStore } from "react";

/**
 * Generic helper to create a boolean external store
 */
const createBooleanStore = (initialValue = false) => {
  let value = initialValue;
  const listeners = new Set();

  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };

  const getSnapshot = () => value;

  const setValue = (next) => {
    value = typeof next === "function" ? next(value) : next;
    listeners.forEach((l) => l());
  };

  const useValue = () => useSyncExternalStore(subscribe, getSnapshot);

  return [useValue, setValue];
};

/* ─────────────────────────────── */
/*  Export globals correctly */
/* ─────────────────────────────── */

export const [useAllVideoPaused, setAllVideoPaused] = createBooleanStore(false);
